<div class="login-wrapper">
  <app-login-scene></app-login-scene>

  <div class="card-frame">
  <div class="login-card">
    <div class="login-header">
      <div class="logo-red"></div>
    </div>

    <form class="form" [formGroup]="form" *ngIf="!isNewPassRequired" (ngSubmit)="onSubmit()">
      <label for="email">{{'user.login.email' | transloco}}*</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        placeholder="{{'user.login.placeholderEmail' | transloco}}"
        pInputText
      />

      <label for="password">{{'user.login.password' | transloco}}*</label>
      <p-password
        id="password"
        formControlName="password"
        placeholder="{{'user.login.placeholderPassword' | transloco}}"
        [feedback]="false"
        [toggleMask]="true"
        [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"
      ></p-password>

      <p-button
          type="submit"
          severity="danger"
          [raised]="true"
          [loading]="submitBtnLoading || checkingSession"
          label="{{'user.login.signIn' | transloco}}">
      </p-button>

      <div class="button-wrapper" (click)="signUp()">
        <div class="button-inner">
          <p-button id="btnBack" name="btnBack" label="{{'user.login.signUp' | transloco}}"  [raised]="true"
            styleClass="custom-button"></p-button>
        </div>
      </div>
      <!-- <button
        pButton
        type="button"
        label="{{'user.login.signUp' | transloco}}"
        class="btn-outline"
        (click)="signUp()"
      ></button> -->

      <a class="forgot-link" (click)="forgotPassword()">{{'user.login.forgotPassword' | transloco}}</a>

      <div class="oauth-divider">
        <span>{{'user.login.orContinueWith' | transloco}}</span>
      </div>

      <div class="oauth-buttons">
        <button class="oauth-btn oauth-google" type="button" (click)="loginWithGoogle()">
          <svg class="oauth-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Google
        </button>
        <button class="oauth-btn oauth-apple" type="button" (click)="loginWithApple()">
          <i class="pi pi-apple oauth-icon"></i>
          Apple
        </button>
      </div>

      <div class="lang-box">
        <p-selectButton
          name="language"
          formControlName="language"
          [options]="languageOptions"
          optionLabel="name"
          optionDisabled="disabled"
          (onChange)="fixLanguage($event)"
        >
          <ng-template let-item pTemplate>
            <div [class]="item.class"></div>
          </ng-template>
        </p-selectButton>
      </div>
    </form>

    <form class="form" [formGroup]="changePasswordForm" *ngIf="isNewPassRequired" (ngSubmit)="challengeNewPass()">
    
      <label for="email">{{ 'user.login.email' | transloco }}</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        placeholder="{{ 'user.login.email' | transloco }}"
        [value]="this.f.email.value"
        [readonly]="true"
        pInputText
      />

      <label for="password">{{ 'user.account.changePassword.modal.inputNewPassword' | transloco }}"</label>
      <p-password class="ig-pass" 
        id="newPassword" 
        name="newPassword" 
        formControlName="newPassword"
        placeholder="{{ 'user.account.changePassword.modal.inputNewPassword' | transloco }}" 
        [feedback]="false"
        [toggleMask]="true" 
        [style]="{'width':'100%'}" 
        [inputStyle]="{'width':'100%'}" 
      />

      <div style="display: grid; margin: 10px;">
        <small style="margin: 5px;" id="password-help">
          {{ 'user.createAccount.passwordText' | transloco }}
        </small>
          <p-button
            type="submit"
            severity="danger"
            [raised]="true"
            [loading]="submitBtnLoading"
            label="{{'user.login.signIn' | transloco}}">
          </p-button>
      </div>
    </form>
  </div>
  </div>
  <p-toast key="toastMessages" />
</div>


